import axios from "axios";
export const port = ":443" //for 172.22.10.14
//export const port = ":811" //for 172.22.10.15
// export const port = ":821" //for 172.22.10.16
console.log(process.env.NODE_ENV)
let address = window.location.protocol + "//" + window.location.hostname + port + "/api"
const isDebug = process.env.NODE_ENV === "development" ? true : false;
if(isDebug) {
    address = window.location.protocol + "//" + "172.22.10.14" + port
}
export const saveKeyValue = async(key,value) => {
    await axios.post(`${address}/common/saveKeyValue`, {key: key, value: value})
}

export const getKeyValue = async(key) => {
    const result = (await axios.get(`${address}/common/getKeyValue`, {params: {key: key}})).data;
    return result;
}